module.exports = __webpack_public_path__ + "img/back-icon.c47203ca.svg";